export const CITIES = {
  FETCH: "CITIES_FETCH",
  FETCH_SUCCESS: "CITIES_FETCH_SUCCESS",
  FETCH_FAILURE: "CITIES_FETCH_FAILURE",
};